import { useState } from "react";
import { Drama } from "lucide-react";

export function TheatreImage({ src, alt, className = "" }) {
  const [failed, setFailed] = useState(false);
  if (!src || failed) {
    return (
      <div className={`flex items-center justify-center bg-secondary text-muted-foreground ${className}`}>
        <Drama className="h-8 w-8 opacity-40" />
      </div>
    );
  }
  return (
    <div className={`relative overflow-hidden bg-secondary ${className}`}>
      <img
        src={src}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 h-full w-full scale-110 object-cover opacity-60 blur-xl"
      />
      <img
        src={src}
        alt={alt}
        loading="lazy"
        onError={() => setFailed(true)}
        className="relative h-full w-full object-contain"
      />
    </div>
  );
}